export class OrderPayment {
    constructor(data) {
        if (data) {
            this.subTotal = data.subTotal || [];
            this.orderNumber = data?.id || data?.code || '';
            this.affiliateOrderNumber = data.affiliateOrderNumber || '';
            this.paymentType = data.paymentType || '';
            this.isInvoiceDocReady = data.isInvoiceDocReady || false;
            this.isCreditNoteDocReady = data.isCreditNoteDocReady || false;
            this.isETaxReady = data.isETaxReady || false;
            this.en_message = data.en_message || '';
            this.errorCode = data.errorCode || '';
            this.technicalError = data.technicalError || '';
            this.th_message = data.th_message || '';
        }
    }

    get isNotValid() {
        return !this.orderNumber;
    }
}